import {
  AUTH_USER,
  UNAUTH_USER,
  AUTH_ERROR,
  AUTH_LOADING,
  DEFAULT,
  FORGOT_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST,
  USER_HOSTS
} from './AuthActions';

const INITIAL_STATE = {
  error: '',
  message: '',
  content: '',
  resetPassStatus: false,
  authenticated: false,
  isLoading: true,
  hosts: [],
  user: {
    expired: true,
    accounts: [],
    config: {},
    permissions: {},
  },
};

const AuthReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AUTH_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case AUTH_USER:
      return {
        ...state,
        error: '',
        message: '',
        resetPassStatus: false,
        authenticated: true,
        isLoading: false,
        user: action.payload,
      };
    case USER_HOSTS:
      return {
        ...state,
        hosts: action.payload,
      };
    case UNAUTH_USER:
      return { ...state, resetPassStatus: false, authenticated: false };
    case AUTH_ERROR:
      return { ...state, resetPassStatus: false, error: action.payload };
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        error: '',
        message: '',
        resetPassStatus: true,
        authenticated: true,
      };
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        error: '',
        message: '',
        resetPassStatus: true,
        authenticated: false,
      };
    case DEFAULT:
      return { ...state, error: '', message: '' };
  }

  return state;
};

export default AuthReducer;
